// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__sdVkV","modal":"styles_modal__-xFwl","buttons":"styles_buttons__08eni","confirm":"styles_confirm__X3hIG"};